@if (visible) {
  <span
    class="cw-md-label cw-md-label--warning"
    data-id="toolbar-report-backend"
    title="Reports from panel-clickhouse (zp_panel cookie)"
  >ClickHouse</span>
}
